import "@/lib/_jquery";
import { HideByCheckbox, ShowByCheckbox } from "@/lib/helpers/HideByCheckbox";

$(function() {
  // Hide element depending on checkbox
  $("[data-hide-by-checkbox]").each(function() {
    try {
      new HideByCheckbox(this).connect();
    } catch {
      console.log("Failed to find checkbox for HideByCheckbox")
    }

  });

  $("[data-show-by-checkbox]").each(function() {
    try {
      new ShowByCheckbox(this).connect();
    } catch {
      console.log("Failed to find checkbox for ShowByCheckbox")
    }
  });

  // Hide element depending on checkbox
  $("[data-hide-by-select]").each(function() {
    const $area = $(this);
    const $select = $($(this).data("hide-by-select"));
    const select_value = $(this).data("hide-by-select-value").toString();

    const activate = function() {
      const value = $(this).val();
      $area.toggleClass("d-none", value === select_value);
    };

    $select.change(activate);
    $select.trigger("change");
  });

  document.querySelectorAll("[data-show-by-select]").forEach(element => {
    const showBySelect = (element as HTMLSelectElement).dataset.showBySelect;
    const showBySelectValue = (element as HTMLSelectElement).dataset.showBySelectValue;
    const select: HTMLSelectElement = document.querySelector(showBySelect);

    function listener() {
      return element.classList.toggle("d-none", select.value !== showBySelectValue);
    }

    select.addEventListener("change", listener);
    listener();
  });


  $(function () {
    $("[data-bs-toggle='tooltip']").tooltip();
  });


  // Focus first input or first input with error
  $(".fn-slick-form-focus form").each(function() {
    if (window.navigator.userAgent === "playwright") return;
    let focusedElement = $(".is-invalid:input:visible").not(":button").first();
    if (focusedElement.length === 0) {
      focusedElement = $(":input:visible").not(":button").first();
    }

    // Select text on focus
    focusedElement.on("focus", function () {
      // Delay sightly to allow focus to "stick" before selecting.
      setTimeout(function() { focusedElement.select(); }, 50);
    });

    // Focus the first input of form
    focusedElement.focus();
  });

  // This is only needed one place.
  // Don't know how to utilise
  // "fn-slick-form-focus" on election config forms
  // without it jumping to bottom of page.
  $(".stay-top").each(function() {
    $(document).scrollTop(0);
  });
});

$(function() {
  const counters = $("[id^='counter_']");

  counters.each(function(i, val) {
    const counter = $(`#${val.id}`);
    const identity = counter.data("identity");
    const textArea = $(`${identity}`);
    counter?.text((textArea.val() as string[]).length);
    textArea.on("input", function() {
      counter?.text(($(this).val() as string[]).length);
    });
  });
});

$(function() {
  const wysiwygCounters = [];
  $($(".trumbowyg-box")).each(function (_i, v) {
    if ($(v).find("textarea")[0].maxLength > 0) {
      wysiwygCounters.push($(v));
    }
  });

  const counters = [];
  $("[id^='richcounter_']").each(function(_i, v) {
    counters.push($(v));
  });

  $(wysiwygCounters).each(function(index, val) {
    const textarea = val.find("textarea")[0];
    const editor = val.find(".trumbowyg-editor")[0];
    const counter = counters[index];
    counter?.text(editor.innerText.length);
    $(textarea).on("tbwchange", function() {
      counter?.text(editor.innerText.length);
    });
  });
});
